import { useEffect } from 'react'
import { UPDATE, useLocaleState, usePermissions, useResourceContext } from 'react-admin'

import config from './config'
import { useApi } from '../../api/apiProvider'
import { SYSTEM_PERMISSION_READ, SYSTEM_PERMISSION_UPDATE } from '../../config/permissions'
import { useIsFieldPermissionDenied, useResourcePermissions } from '../../domain/permissions'

export const useGetBookingsJustifications = () => {
  const [locale] = useLocaleState()
  const [hasRead] = useResourcePermissions(config.name, SYSTEM_PERMISSION_READ)
  const [fetchBookingsJustifications, { data: bookingsJustifications }] = useApi('/bookings/justifications', {
    method: 'GET',
    params: { locale },
  })
  useEffect(() => {
    if (hasRead) fetchBookingsJustifications()
  }, [fetchBookingsJustifications, hasRead])
  return bookingsJustifications
}

export const useCanEditBookings = () => {
  const [hasEdit] = useResourcePermissions(config.name, SYSTEM_PERMISSION_UPDATE)
  const commonProps = { resource: config.name, action: UPDATE }

  const isStartRestricted = useIsFieldPermissionDenied({ ...commonProps, source: 'start_scheduled_on' })
  const isEndRestricted = useIsFieldPermissionDenied({ ...commonProps, source: 'end_scheduled_on' })

  if (!hasEdit) return false

  return !isStartRestricted && !isEndRestricted
}
